import type { FC } from 'react';
import PropTypes from 'prop-types';
import { useContentAsset } from '../../bff-api/content/useContentAsset';
import { Content } from './Content';

interface Props {
    className?: string;
    contentAssetId: string;
}

export const ContentAsset: FC<Props> = ({ contentAssetId, className }) => {
    const { data } = useContentAsset(contentAssetId);
    return <Content serverHtml={data?.html} className={className} />;
};

ContentAsset.propTypes = {
    contentAssetId: PropTypes.string.isRequired,
    className: PropTypes.string,
};

ContentAsset.defaultProps = {
    className: undefined,
};
